import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import psswordLogo from '../../assests/images/passwordanimation.gif';

import"./style.scss";

const Modals = ({ show, handleClose, handleSubmit }) => {
  return (
<Modal show={show} onHide={handleClose} centered className="custom-modal">
  
      <Modal.Body>
        
       <img src={psswordLogo} alt="alert" className='git'/> 
        <h4>Reset Password</h4>
        <p>Are you sure you want to reset the password to <span>“Test@123” ?</span></p>
        </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleSubmit}>
          Yes
        </Button>
        <Button variant="primary" onClick={handleClose}>
          No
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default Modals;
